import React, { useEffect, useRef } from "react";
import { useVoiceContext } from "@/context/voiceContext";

const VoiceBackground: React.FC = () => {
  const { voiceLevel, isListening } = useVoiceContext();
  const bgRef = useRef<HTMLDivElement>(null);
  const intensityRef = useRef(0);
  const frameRef = useRef<number>(null);

  useEffect(() => {
    const smoothing = 0.3;

    const loop = () => {
      if (!bgRef.current || !isListening) {
        intensityRef.current = 0;
      } else {
        const target = voiceLevel * 100;
        intensityRef.current += (target - intensityRef.current) * smoothing;
      }

      const opacity = Math.max(0.4, intensityRef.current / 100);
      const radius = Math.max(30, intensityRef.current * 2);

      bgRef.current!.style.setProperty("--voice-opacity", String(opacity));
      bgRef.current!.style.setProperty("--voice-radius", `${radius}%`);

      frameRef.current = requestAnimationFrame(loop);
    };

    frameRef.current = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(frameRef.current!);
  }, [voiceLevel, isListening]);

  // Only show secondary layer when intensity > threshold:
  const showSecondary = intensityRef.current > 20;
  const showPulse = intensityRef.current > 50;

  return (
    <div className="fixed inset-0 -z-10">
      <div ref={bgRef} className="voice-bg" />
      {showSecondary && <div className="voice-bg secondary" />}
      {showPulse && <div className="voice-bg pulse" />}
    </div>
  );
};

export default VoiceBackground;
